import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CardBody from 'components/Card/CardBody';
import CardIcon from 'components/Card/CardIcon';
import LocationCity from '@material-ui/icons/LocationCity';
import HighlightOff from '@material-ui/icons/HighlightOff';
import { HeadingSBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import CanPerform from 'components/CanPerform/CanPerform';
import Edit from '@material-ui/icons/Edit';
import TextWithIconInBackground from 'components/TextWithIconInBackground/TextWithIconInBackground';
import Card from 'components/Card/Card';
import React, { useState } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/departmentDetailsStyle';
import { makeStyles } from '@material-ui/core';
import EditDepartmentDialog from './subcomponents/EditDepartmentDialog';
import DeleteDepartmentConfirmationDialog from './subcomponents/DeleteDepartmentConfirmationDialog';
import LocalPhoneOutlined from '@material-ui/icons/LocalPhoneOutlined';
import SupervisorAccountOutlined from '@material-ui/icons/SupervisorAccountOutlined';
import GridItem from 'components/Grid/GridItem';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDepartmentDetailsHeaderProps {
	notAssigned: boolean;
	department: types.organizations.IExtendedDepartmentDetails | null;
	editDepartment: (name: string, uiColor: string) => void;
	deleteDepartment: () => void;
}

const DepartmentDetailsHeader = ({
	notAssigned,
	department,
	editDepartment,
	deleteDepartment,
}: IDepartmentDetailsHeaderProps) => {
	const [editDepartmentDialog, setEditDepartmentDialog] = useState<boolean>(false);
	const [deleteDepartmentConfirmationDialog, setDeleteDepartmentConfirmationDialog] = useState<boolean>(false);
	const classes = useStyles();

	return (
		<ConditionalRender
			show={!!department && !!department.departmentData}
			onTrue={() => (
				<GridItem xs={12}>
					<Card>
						<CardBody className={classes.cardBody}>
							<div className={classes.nameBlock}>
								<CardIcon
									color="warning"
									size="sm"
									className={classes.cardIcon}
									uiColor={department!.departmentData!.uiColor}
								>
									<ConditionalRender
										show={notAssigned}
										onTrue={() => <HighlightOff />}
										onFalse={() => <LocationCity />}
									/>
								</CardIcon>
								<HeadingSBold color="primary-light">
									{department!.departmentData!.name || translate('department.not.assigned')}
								</HeadingSBold>
								<CanPerform
									action="department:edit-department"
									yes={
										<ConditionalRender
											show={!notAssigned}
											onTrue={() => (
												<>
													<div
														id="edit-department-button"
														className={classes.editButton}
														onClick={() => setEditDepartmentDialog(true)}
													>
														<Edit />
													</div>
													<EditDepartmentDialog
														isOpen={editDepartmentDialog}
														hideDialog={() => setEditDepartmentDialog(false)}
														showConfirmationDialog={() =>
															setDeleteDepartmentConfirmationDialog(true)
														}
														editDepartment={editDepartment}
														departmentData={department!.departmentData}
													/>
													<DeleteDepartmentConfirmationDialog
														isOpen={deleteDepartmentConfirmationDialog}
														hideDialog={() => setDeleteDepartmentConfirmationDialog(false)}
														showEditDepartmentDialog={() => setEditDepartmentDialog(true)}
														deleteDepartment={deleteDepartment}
													/>
												</>
											)}
										/>
									}
								/>
							</div>
							<div className={classes.numbers}>
								<TextWithIconInBackground
									value={department!.departmentData!.numbersCount || '0'}
									text={translate('lines')}
									icon={<LocalPhoneOutlined />}
								/>
								<TextWithIconInBackground
									value={department!.departmentData!.usersCount || '0'}
									text={translate('users')}
									icon={<SupervisorAccountOutlined />}
								/>
							</div>
						</CardBody>
					</Card>
				</GridItem>
			)}
		/>
	);
};

export default DepartmentDetailsHeader;
